module.exports = __webpack_public_path__ + "static/media/r15.e10474a2.jpg";